module.exports = __webpack_public_path__ + "static/media/CRONOS.aa801460.svg";